export default __webpack_public_path__ + "static/media/MaskGroup311.fe4f87dc.png";